<template>
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.86207 1L11 5.48276L6.86207 9.96552"
      stroke="#110F13"
      stroke-width="1.4"
      stroke-linecap="round"
    />
    <path
      d="M11 5.48267L1 5.48267"
      stroke="#110F13"
      stroke-width="1.4"
      stroke-linecap="round"
    />
  </svg>
</template>
